import axios from "axios";
import { KEYS, endSession, isPublicApi } from "@/lib/session";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(KEYS.token);
  // Endpoint publik (/lapor-siport) tidak butuh login: token tidak dikirim.
  if (token && !isPublicApi(config.url)) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.includes("/auth/login") && !isPublicApi(url)) {
      // Punya token tapi ditolak = sesi berakhir. endSession tidak mengalihkan dari /login dan /lapor-siport.
      endSession(localStorage.getItem(KEYS.token) ? "sesi" : "keluar");
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
